import { FC, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import { FloatButton, Layout } from "antd";
import { ArrowUpOutlined, WhatsAppOutlined } from "@ant-design/icons";
import PageRoutes from "./components/PageRoutes";
import MainHeader from "../header/MainHeader";
import MainFooter from "../footer/MainFooter";
import { useWhatsAppApi } from "../../../hooks/useWhatsappApi";
import useResponsive from "../../../hooks/useResponsive";

const { Content } = Layout;

const MainRoutes: FC = () => {
  const [isBackTopVisible, setIsBackTopVisible] = useState(false);
  const sendWhatsAppMessage = useWhatsAppApi();
  const { isMobile, isTablet } = useResponsive();

  useEffect(() => {
    let ticking = false;
    
    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setIsBackTopVisible(window.scrollY > 400);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleWhatsAppClick = () => {
    sendWhatsAppMessage("Hello BIGELEMENT INFOTECH");
  };

  return (
    <Layout className="main-layout">
      <MainHeader />
      <Content>
        <Routes>
          <Route path="/*" element={<PageRoutes />} />
        </Routes>
      </Content>
      <MainFooter />
      <FloatButton.BackTop
        className="back-to-top"
        style={{ bottom: 15 }}
        icon={<ArrowUpOutlined />}
        duration={1}
        aria-label="Scroll to top"
      />
      {(isMobile || isTablet) && (
        <FloatButton
          onClick={handleWhatsAppClick}
          shape="square"
          type="primary"
          style={{
            bottom: isBackTopVisible ? 65 : 15,
            transition: "bottom 0.3s",
          }}
          icon={<WhatsAppOutlined />}
          aria-label="Contact us on WhatsApp"
        />
      )}
    </Layout>
  );
};

export default MainRoutes;
